<ng-container [formGroup]="formGroup">
  <div class="flex gap wrap">
    <mat-form-field class="w-100">
      <mat-label>Nom de la résidence</mat-label>
      <input matInput formControlName="name" [required]="true" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Adresse</mat-label>
      <input matInput formControlName="address" [required]="true" />
    </mat-form-field>
  </div>
  <div class="flex gap wrap">
    <mat-form-field class="w-100">
      <mat-label>Code postal</mat-label>
      <input matInput formControlName="postalCode" [required]="true" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Ville</mat-label>
      <input matInput formControlName="city" appToUppercase [required]="true" />
    </mat-form-field>
  </div>
</ng-container>
